import React from 'react'

export default function ComparisonDetalingLogistics() {
  return (
    <>
      <section className='ComparisonDetalingLogistics-area'>
        <div className='container'>
          <div className='row align-items-center justify-content-center'>
            <div className='col-lg-6 col-md-9 text-center'>
              <h4 className='heading'>What Logistics
                Professionals Are Saying</h4>
            </div>
            </div>

            <div className='row'>
              <div className='col-lg-4 col-md-6 col-sm-12 col-12'>
                <div className='ComparisonDetalingLogistics-cards'>
                  <img src='/assets/images/comparisondetaling-logistics-img-1.webp' className='img-fluid' alt='logos' />
                  <p>Mobility Infotech Logitics transformed our logistics operations with real-time visibility, intelligent dispatch, and route optimization. We significantly improved delivery efficiency, reduced operational costs, and gained complete control over our fleet and transportation network, resulting in faster deliveries and exceptional customer satisfaction.</p>
                  <span>Jennifer Wilson</span>
                  <small>Director of Supply Chain</small>
                </div>
              </div>
              <div className='col-lg-4 col-md-6 col-sm-12  col-12'>
                <div className='ComparisonDetalingLogistics-cards'>
                  <img src='/assets/images/comparisondetaling-logistics-img-2.webp' className='img-fluid' alt='logos' />
                  <p>Mobility Infotech Logistic gave us complete visibility into every shipment while simplifying dispatch and fleet coordination. The platform improved delivery accuracy, reduced manual effort, and helped our teams respond faster to customer demands across multiple regions with outstanding operational efficiency.</p>
                  <span>Daniel Brooks</span>
                  <small>Operations Manager</small>
                </div>
              </div>
              <div className='col-lg-4 col-md-6 col-sm-12  col-12'>
                <div className='ComparisonDetalingLogistics-cards'>
                  <img src='/assets/images/comparisondetaling-logistics-img-3.webp' className='img-fluid' alt='logos' />
                  <p>Choosing Mobility Infotech Logistics was a strategic decision for our growing business. Its scalable logistics platform streamlined workflows, enhanced shipment visibility, and enabled our operations to expand confidently without compromising efficiency or service quality while supporting long-term business growth.</p>
                  <span>Sophia Turner</span>
                  <small>Head of Logistics</small>
                </div>
              </div>
            </div>
          </div>  
      </section>
    </>
  )
}
